import * as types from "./actionTypes";
import * as eventsApi from "../../api/eventsApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";
import moment from "moment"

export function groupEventsLoaded(groupId, events) {
    return { type: types.LOAD_GROUP_EVENTS, groupId, events }
}

export function userEventsLoaded(events) {
    return { type: types.LOAD_USER_EVENTS, events }
}

export function eventLoaded(event) {
    return { type: types.LOAD_EVENT, event }
}

export function eventCreated(event) {
    return { type: types.CREATE_EVENT, event }
}

export function eventEdited(event) {
    return { type: types.EDIT_EVENT, event }
}

export function userParticipationUpdated(eventId, user, status) {
    return { type: types.EVENT_USER_PARTICIPATION_UPDATE, eventId, user, status }
}

export function eventCancelled(eventId, cancellationReason) {
    return { type: types.CANCEL_EVENT, eventId, cancellationReason }
}

export function eventDeleted(eventId) {
    return { type: types.DELETE_EVENT, eventId }
}

const offSet = new Date().getTimezoneOffset();

export function loadUserEvents() {
    return dispatch => {
        return eventsApi.getUserEvents()
            .then(events => {
                events.map(e => {
                    e.fullyLoaded = false;
                })
                dispatch(userEventsLoaded(events));
                return events;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function loadUpcomingUserEvents(numberToLoad) {
    return dispatch => {
        return eventsApi.getUpcomingUserEvents(numberToLoad)
            .then(events => {
                events.map(e => {
                    e.fullyLoaded = false;
                })
                return events;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

/*
export function loadGroupEvents(groupId) {
    return dispatch => {
        return eventsApi.getGroupEvents(groupId)
            .then(events => {
                events.map(e => {
                    e.fullyLoaded = false; 
                })
                dispatch(groupEventsLoaded(groupId, events));
                return { groupId: groupId, events: events };
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}
*/

export function loadEvent(eventId) {
    return dispatch => {
        return eventsApi.getEvent(eventId)
            .then(event => {
                event.fullyLoaded = true
                event.startDate = moment(event.startDate).subtract(offSet, 'm');
                event.finishDate = moment(event.finishDate).subtract(offSet, 'm');

                dispatch(eventLoaded(event));
                return event;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function createEvent(event) {

    //alert(`name: ${event.name} description: ${event.description} start: ${event.startTime} end: ${event.endTime} routeID: ${event.route} groupID: ${event.group}`);
    event.routeIds = [event.routeId];
    event.routes = [{ id: event.route.id, name: event.route.name }];

    return dispatch => {
        return eventsApi.saveEvent(event)
            .then(eventId => {
                event.id = eventId;
                event.fullyLoaded = false;
                dispatch(eventCreated(event));
                return event;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }

}

export function editEvent(event) {
    event.routeIds = [event.routeId];
    event.routes = [{ id: event.route.id, name: event.route.name }];

    return dispatch => {
        return eventsApi.saveEvent(event)
            .then(() => {
                event.fullyLoaded = false;
                dispatch(eventEdited(event));
                return event;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function updateUserParticipation(eventId, user, status) {
    return dispatch => {
        return eventsApi.setUserParticipation(eventId, user, status)
            .then(() => {
                dispatch(userParticipationUpdated(eventId, user, status));
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function cancelEvent(eventId, cancellationReason) {
    return dispatch => {
        return eventsApi.cancelEvent(eventId, cancellationReason)
            .then(() => {
                dispatch(eventCancelled(eventId, cancellationReason));
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function deleteEvent(eventId) {
    return dispatch => {
        return eventsApi.deleteEvent(eventId)
            .then(() => {
                dispatch(eventDeleted(eventId));
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}




// WEBPACK FOOTER //
// ./src/redux/actions/eventActions.js